export type GraphBarColor = 'primary' | 'destructive' | 'muted';

/**
 * Retourne une couleur de barre basée sur le signe de la valeur.
 * - > 0 => 'primary'
 * - < 0 => 'destructive'
 * - = 0 => 'muted'
 */
export function getGraphBarColorClass(totalValue: number): GraphBarColor {
  if (totalValue > 0) return 'primary';
  if (totalValue < 0) return 'destructive';
  return 'muted';
}

/**
 * Construit le fill HSL pour un graphique BarChartBloc à partir d'une valeur.
 * Exemple: hsl(var(--primary))
 */
export function getBarFillFromValue(totalValue: number): string {
  const color = getGraphBarColorClass(totalValue);
  return `hsl(var(--${color}))`;
}
